import Oidc from 'oidc-client';
import store from "../store";
import config from "../settings/config.js"

var mgr =
  new Oidc.UserManager({
    authority: config.identity.authority,
    client_id: config.identity.client_id,
    redirect_uri: config.identity.redirect_uri,
    response_type: 'code',
    scope: 'openid profile email api1',
    post_logout_redirect_uri: config.identity.post_logout_redirect_uri,
    userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),

    automaticSilentRenew: true,
    silent_redirect_uri: config.identity.silent_redirect_uri,
    accessTokenExpiringNotificationTime: 10
  })

const userAuth = {
  data() {
    return {
      user: {
        isAuthenticated: store.getters["login/isAuthenticated"],
        name: store.getters["login/profile.name"],
        user: store.getters["login/user"]
      }
    }
  },
  GetUserName() {
    if (store.getters["login/isAuthenticated"]) {
      let obj = store.getters["login/user"];
      return obj.profile.name;
    }
    return "";
  },
  CheckIfRerral() {
    if (store.getters["login/isAuthenticated"]) {
      let obj = store.getters["login/user"];
      return obj.profile.ReferralFirstLogin;
    }
    return "";
  },
  async GetUserDetail() {
    const user = await mgr.getUser();
    if (!!user) {
      store.dispatch('login/setUser', user).then(a => {
        }).catch(err => {
        console.error(err);
      });
    }
    return user;
  },
  async authenticate(returnPath) {
    const user = await this.GetUserDetail();
    if (user == null)
      await this.signIn(returnPath);
  },
  
  signIn(returnPath) {
    returnPath ? mgr.signinRedirect({ state: returnPath })
      : mgr.signinRedirect();
  },

  SignOut() {
    let obj = store.getters["login/user"];
    store.dispatch('login/logOutUser').then(a => {
      window.localStorage.removeItem('vuex');
      window.localStorage.clear();
      if (obj.isManualLogin == null) {
        mgr.signoutRedirect({ 'id_token_hint': obj.id_token });
      }
      else {
        window.location = '/';
      }
    }).catch(err => {
      console.error(err);
    });
  },
  
  async CallBack() {
    try {
      let result = await mgr.signinRedirectCallback();
      let returnToUrl = '/Airtime';
      if (result.state !== undefined) { returnToUrl = result.state; }
      {
        await this.GetUserDetail();
        window.location = returnToUrl;
      }
    }
    catch (e) {
      console.log(e);
    }
  }
}

export { mgr as default, userAuth };